import { normalizeString } from "./string-fns.ts";

/**
 * Formats a load status string into a user-friendly display string.
 * This is used for both display in the UI and for filtering in grids.
 */
export const getFormattedLoadStatus = (
	status: string | null | undefined,
): string => {
	if (!status) return "N/A";

	const statusDisplayMap: Record<string, string> = {
		PICKED_UP: "In Transit",
		PENDING: "Not Dispatched",
	};

	return statusDisplayMap[status] || normalizeString(status);
};

/**
 * Formats load status for external users:
 * - Tendered: Not Dispatched or Dispatched
 * - In Transit: Picked up, Not Delivered
 * - Delivered: Delivered
 */
export const getFormattedLoadStatusExternal = (
	status: string | null | undefined,
): string => {
	if (!status) return "N/A";

	const normalizedStatus = status.toUpperCase();

	const deliveredStatuses = ["DELIVERED"];
	const inTransitStatuses = ["PICKED_UP", "IN_TRANSIT", "NOT_DELIVERED"];

	if (deliveredStatuses.includes(normalizedStatus)) return "Delivered";
	if (inTransitStatuses.includes(normalizedStatus)) return "In Transit";

	return "Tendered";
};
